import {PricingModelCardsFormField} from "../../../../general/pricing/pricing-model-cards";

export {
  PWYW_CARD_TITLE,
  PWYW_CARD_DESCRIPTION,
} from "../../../../general/pricing/pricing-model-cards";

/**
 * The Product Service's Pricing Model.
 *
 * Nothing of its own: a Product Service has no Add-ons, so every choice applies straight
 * away and the shared cards do the whole job.
 */
export function ServiceSubPricingCostFormField() {
  return <PricingModelCardsFormField />;
}
